const stats = [
  { value: "4 类", label: "按主题分组" },
  { value: "20 部", label: "精选条目" },
  { value: "中字 · 高清", label: "观看重点" },
  { value: "1970s 至今", label: "经典年表" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20cinematic%20atmosphere%20of%20warm%20amber%20and%20deep%20brick%20red%20light%20beams%20passing%20through%20dusty%20air%2C%20moody%20theatrical%20stage%20curtains%20blurred%20in%20background%2C%20vintage%2035mm%20film%20grain%2C%20dramatic%20chiaroscuro%20shadows%2C%20artistic%20painterly%20composition%20without%20people%2C%20rich%20contrast%20for%20text%20overlay&width=1920&height=1080&seq=ethics-hero-cine&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent"></div>

      <div className="relative z-10 w-full px-4 md:px-10 lg:px-16 py-24 md:py-28">
        <div className="max-w-5xl mx-auto animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-100 text-xs md:text-sm font-label tracking-wide">
            <i className="ri-bookmark-3-line"></i>
            中字 · 高清 · 合集 · 经典与推荐
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-background-50 text-balance">
            看懂欧美伦理电影，
            <br className="hidden sm:block" />
            从一段关系和一次选择开始
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/90">
            这里整理以家庭、婚姻、亲密关系与社会道德处境为核心的欧美剧情片，按主题分组、标明出品年份与地区，
            并提供中文字幕与高清版本的观看要点，帮你判断一部片子是不是此刻想看的。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#collection"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-list-2-line text-lg"></i>
              浏览精选片单
            </a>
            <a
              href="#subtitle"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/12 border border-background-50/35 text-background-50 text-sm font-label font-medium hover:bg-background-50/22 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-closed-captioning-line text-lg"></i>
              先看中字指南
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-5 max-w-3xl">
            {stats.map((s) => (
              <div key={s.label} className="border-l-2 border-accent-400/70 pl-3">
                <dt className="text-accent-200 text-xs font-label tracking-wide">{s.label}</dt>
                <dd className="mt-1 font-heading text-xl md:text-2xl font-semibold text-background-50">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}